import { forwardRef } from "react";

import styles from "./RadioTile.module.css";
import type { RadioProps } from "../Radio.types";
import { useRadio } from "../hooks/useRadio";
import { classNames, mergeRefs } from "../../../utils/common";
import { Checkmark } from "@certa/icons/components/Checkmark";
import { Circle } from "@certa/icons/components/Circle";

export const RadioTile = forwardRef<HTMLInputElement, RadioProps>(
  (props, ref) => {
    const { label: radioLabel } = props;
    const {
      radioId,
      inputProps,
      isChecked,
      isDisabled,
      hasError,
      handleWrapperClick
    } = useRadio(props);

    return (
      <div
        className={classNames({
          [styles.catalystRadioTile]: true,
          [styles.catalystRadioTileChecked]: isChecked,
          [styles.catalystRadioTileDisabled]: isDisabled,
          [styles.catalystRadioTileError]: hasError
        })}
        onClick={handleWrapperClick}
      >
        <div className={styles.catalystRadioTileInputContainer}>
          <input
            {...inputProps}
            ref={mergeRefs([ref, inputProps.ref])}
            type="radio"
            className={styles.catalystRadioTileInput}
          />
          {isChecked ? (
            <Checkmark
              className={styles.catalystRadioTileIcon}
              data-testid="checkmark-icon"
            />
          ) : (
            <Circle
              className={styles.catalystRadioTileIcon}
              data-testid="circle-icon"
            />
          )}
        </div>
        {/*
        Do not add the input inside the label, it will break the accessibility
        by not reading the group label when used in group role in Firefox.
      */}
        <label htmlFor={radioId}>{radioLabel}</label>
      </div>
    );
  }
);
